import { makeStyles } from 'tss-react/mui';

interface StylesProps {
  listStyleType: string;
  pl: number;
}

const useStyles = makeStyles<StylesProps>()((theme, { listStyleType, pl }) => ({
  list: {
    fontSize: 'inherit',
    color: 'inherit',
    listStyleType: listStyleType,
    paddingLeft: theme.spacing(pl),
  },
}));

export default useStyles;
